export default __webpack_public_path__ + "static/media/help.ab83ff6e.svg";